'use client';

interface StepperControlProps {
    label: string;
    value: number;
    min: number;
    max: number;
    onChange: (value: number) => void;
}

export default function StepperControl({ label, value, min, max, onChange }: StepperControlProps) {
    const decrement = () => {
        if (value > min) onChange(value - 1);
    };

    const increment = () => {
        if (value < max) onChange(value + 1);
    };

    return (
        <div className="flex flex-col gap-2">
            <label className="text-[11px] font-medium uppercase tracking-[0.05em] text-muted">
                {label}
            </label>
            <div className="flex items-center gap-2">
                <button onClick={decrement} disabled={value <= min} className="h-8 w-8 p-0">
                    −
                </button>
                <div className="flex h-8 flex-1 items-center justify-center rounded-sm border-[0.5px] border-line bg-surface text-sm">
                    {value}
                </div>
                <button onClick={increment} disabled={value >= max} className="h-8 w-8 p-0">
                    +
                </button>
            </div>
        </div>
    );
}
